module.exports = __webpack_public_path__ + "img/feedback_thankyou_robot.e729d99e.png";